<div class="header-bar">
  <h1>Supplier Tagging Administration</h1>
</div>
<div class="content-container">
  <div class="general-container ui-g">
    <div class="ui-g-6 general-tags-container card">
      <div class="tag-container" *ngFor="let tag of tags">
        <div
          class="ui-g"
          style="display: flex; flex-wrap: nowrap"
          [ngClass]="{ 'tag-name-inactive': tag.inactiveDate != null }"
        >
          <div style="flex-shrink: 1">
            <p-checkbox
              #tagCheckbox
              binary="true"
              class="ui-g-1 tag-checkbox"
              (onChange)="onTagCheckChanged($event, tag)"
            >
            </p-checkbox>
          </div>

          <div class="tag-name">
            {{ tag.name }}
          </div>
          <div
            style="flex-grow: 1"
            [ngClass]="{ 'tag-description-inactive': tag.inactiveDate != null }"
            class="tag-description"
          >
            {{ tag.description }}
          </div>
        </div>
      </div>

      <div class="ui-grid-row centered-buttons" style="margin-top: 15px">
        <button
          type="button"
          class="green-btn"
          pButton
          icon="fa ui-icon-check"
          (click)="applyGeneralTags()"
          label="Apply Tags"
          pTooltip="Allocate the selected tags to the selected suppliers"
        ></button>
        <button
          type="button"
          class="red-btn"
          pButton
          icon="fa ui-icon-close"
          label="Remove Tags"
          pTooltip="Remove all tags from the selected suppliers"
          (click)="removeGeneralTags()"
        ></button>

        <span style="display: inline-block; padding-left: 10px; line-height: 28px; cursor: pointer">
          <a routerLink="/app/tagging-admin" target="_blank"
            >Edit Tags <i class="fa fa-external-link"></i
          ></a>
        </span>
      </div>
    </div>
    <div class="ui-g-6 py-0">
      <div
        class="include-customers-container card"
        style="display: flex; flex-direction: column; grid-gap: 10px"
      >
        <div
          *ngIf="!selectedCustomers || selectedCustomers?.length == 0"
          style="font-size: 13px; padding-left: 8px"
        >
          Select customers who will be approved to work with the suppliers selected below.
        </div>
        <div class="centered-buttons" style="flex-shrink: 1">
          <button
            type="button"
            class="blue-btn"
            pButton
            (click)="selectCustomerInclusions()"
            label="Select Customers.."
          ></button>
          <button
            *ngIf="selectedCustomers && selectedCustomers.length > 0"
            type="button"
            class="orange-btn"
            pButton
            (click)="clearCustomerSelection()"
            label="Clear Customer Selection"
          ></button>
        </div>

        <!-- show list of customers selected from dialog -->
        <div class="include-customers-list" style="flex-grow: 1">
          <div *ngIf="selectedCustomers && selectedCustomers.length > 0">
            <div class="selected-customers">Selected customers:</div>
            <ol style="height: 88px; max-height: 88px; overflow-y: auto">
              <li *ngFor="let customer of selectedCustomers">{{ getCustomerName(customer) }}</li>
            </ol>
          </div>
        </div>

        <div class="include-customers-reason" style="flex-shrink: 1">
          <div style="display: flex; grid-gap: 5px; flex-direction: column">
            <div style="flex-grow: 1">
              <textarea
                pInputTextarea
                [rows]="3"
                [cols]="80"
                [(ngModel)]="includeCustomersReason"
                [maxlength]="2048"
                class="include-customers-text"
                placeholder="Reason for exclusive inclusion"
              ></textarea>
            </div>
            <div style="flex-shrink: 1">
              <button
                type="button"
                class="green-btn"
                pButton
                icon="fa ui-icon-check"
                (click)="applyGeneralInclusions()"
                label="Apply Inclusions"
                pTooltip="Apply the selected customers to the 'Can work for' column of selected suppliers"
                [disabled]="
                  !selectedCustomers ||
                  selectedCustomers?.length == 0 ||
                  !selectedSuppliers ||
                  selectedSuppliers?.length == 0
                "
              ></button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <tagging-select-supplier
    #taggingSelectSupplier
    (selectedSuppliersChanged)="onSelectedSuppliersChanged($event)"
    (removeInclusion)="onRemoveInclusions()"
    [parentSelectedSuppliers]="selectedSuppliers"
  ></tagging-select-supplier>

  <p-dialog
    header="Customers List"
    #customerDialog
    [(visible)]="showCustomerDialog"
    [modal]="true"
    [style]="{ width: '900px', height: '750px' }"
    [responsive]="true"
    (visibleChange)="onCustomerSelectionDialogClosed()"
  >
    <div class="customer-container">
      <tagging-select-customer
        (selectedCustomersChanged)="onSelectedCustomersChanged($event)"
        [parentSelectedCustomers]="selectedCustomers"
      >
      </tagging-select-customer>
    </div>
  </p-dialog>
</div>
